import { createContext } from 'react';
import noop from 'lodash/noop';
import { initialDateRange } from './constants';
export const FilterContext = createContext({
    config: [],
    filteredData: [],
    onSelectFilter: noop,
    onSelectDateRange: noop,
    onClearFilters: noop,
    dateRange: initialDateRange,
    countTotalAppliedValues: 0,
    appliedFilters: {
        filters: {},
        dateRange: {
            from: undefined,
            to: undefined,
        },
    },
    filterSearchParams: [],
    analyticsFilterData: {
        filters: {},
        dateRange: {
            from: undefined,
            to: undefined,
        },
    },
});
